import { useTranslation } from "react-i18next";
import { useBranding } from "../context/BrandingContext";

export function BrandedFooter() {
  const { t } = useTranslation();
  const branding = useBranding();

  return (
    <footer className="mt-10 text-center text-xs text-gray-400 space-y-1">
      {branding.powered_by_visible && (
        <p>
          Powered by{" "}
          <span className="font-medium">wifi-helpdesk</span>
        </p>
      )}
      {(branding.support_email || branding.support_phone) && (
        <p>
          {branding.support_email && (
            <a href={`mailto:${branding.support_email}`} className="hover:underline">
              {branding.support_email}
            </a>
          )}
          {branding.support_email && branding.support_phone && " · "}
          {branding.support_phone && <span>{branding.support_phone}</span>}
        </p>
      )}
      {(branding.privacy_url || branding.impressum_url) && (
        <p>
          {branding.privacy_url && (
            <a href={branding.privacy_url} target="_blank" rel="noopener noreferrer" className="hover:underline">
              {t("footer_privacy")}
            </a>
          )}
          {branding.privacy_url && branding.impressum_url && " · "}
          {branding.impressum_url && (
            <a href={branding.impressum_url} target="_blank" rel="noopener noreferrer" className="hover:underline">
              {t("footer_impressum")}
            </a>
          )}
        </p>
      )}
    </footer>
  );
}
